import { workspaceModel } from 'APP/model/model';
import { IWorkspace } from 'APP/model/workspace/workspaceModel.types';
import Entities from 'STORE';

export async function updateWorkspace(data: Partial<IWorkspace>): Promise<boolean> {
  try {
    const result = await workspaceModel.updateWorkspace(data);

    Entities.workspace.updateWorkspace({
      name: Entities.workspace.name,
      description: Entities.workspace.description,
      avatarUrl: Entities.workspace.avatarUrl || undefined,
      usersCount: Entities.workspace.membersCount,
      ...result,
    });

    return true;
  } catch {
    return false;
  }
}
